/** Platform navigation and category configuration. */

// Empty string = same-origin /api (single Railway service).
// Local `npm start` also uses '' + setupProxy → localhost:8000.
// Override with REACT_APP_API_URL only when API is on a different host.
export const API_BASE_URL = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');

export const HOME_ROUTE = { path: '/', label: 'Home' };

export const EXTRACT_ROUTE = { path: '/extract', label: 'Extract Links' };

export const JOB_QUEUE_ROUTE = { path: '/queue', label: 'Job links' };

export const AUTOMATION_ROUTE = { path: '/automation', label: 'Automation' };

export const DATABASE_ROUTE = { path: '/database', label: 'Database' };

export const TEMPLATE_ROUTE = { path: '/templates', label: 'Templates' };

export const MEETINGS_ROUTE = { path: '/meetings', label: 'Interviews' };

export const MEETINGS_MANAGE_ROUTE = { path: '/meetings/manage', label: 'Manage interviews' };

export const MEETINGS_CALENDAR_ROUTE = { path: '/meetings/calendar', label: 'Calendar' };

export const MEETINGS_OUTLOOK_ROUTE = { path: '/meetings/outlook', label: 'Outlook check' };

export const EMAIL_OUTCOME_RESULTS_ROUTE = {
  path: '/meetings/email-outcomes',
  label: 'AI email results',
};

export const CALLERS_ROUTE = { path: '/callers', label: 'Callers' };

export const AVAILABILITY_ROUTE = { path: '/availability', label: 'Availability' };

export const CALLER_ANALYSIS_ROUTE = {
  path: '/callers/:callerId/analysis',
  label: 'Caller analysis',
};

export const USERS_REGISTER_ROUTE = { path: '/users/register', label: 'Users' };

export const TEAMS_ROUTE = { path: '/teams', label: 'Teams' };

export const ACCOUNT_ROUTE = { path: '/account', label: 'Account' };

export const SLACK_BID_RESULTS_ROUTE = { path: '/slack/bid-results', label: 'Submissions' };

export const EMAIL_CHECKER_ROUTE = { path: '/email-checker', label: 'Email Checker' };

export const EMAIL_NOTICES_ROUTE = { path: '/email-notices', label: 'Email Notices' };

export const CATEGORY_PAGES = [
  {
    id: 'AI/ML',
    path: '/ai',
    label: 'AI/ML',
    promptChoice: 'gpt',
    promptFile: 'ResumeGPT.txt',
    description: 'Generate resumes for AI and machine learning roles using the ResumeGPT prompt.',
  },
  {
    id: 'SAP',
    path: '/sap',
    label: 'SAP',
    promptChoice: 'sap',
    promptFile: 'ResumeSAP.txt',
    description: 'Generate SAP-focused resumes using the dedicated ResumeSAP prompt.',
  },
  {
    id: 'Salesforce',
    path: '/salesforce',
    label: 'Salesforce',
    promptChoice: 'salesforce',
    promptFile: 'ResumeSalesforce.txt',
    description: 'Generate Salesforce-focused resumes using the dedicated ResumeSalesforce prompt.',
  },
  {
    id: 'ServiceNow',
    path: '/servicenow',
    label: 'ServiceNow',
    promptChoice: 'servicenow',
    promptFile: 'ResumeServiceNow.txt',
    description: 'Generate ServiceNow-focused resumes using the dedicated ResumeServiceNow prompt.',
  },
  {
    id: 'DevOps',
    path: '/devops',
    label: 'DevOps',
    promptChoice: 'devops',
    promptFile: 'ResumeDevOps.txt',
    description: 'Generate DevOps, SRE, and platform engineering resumes using the dedicated ResumeDevOps prompt.',
  },
  {
    id: 'FullStack',
    path: '/fullstack',
    label: 'FullStack',
    promptChoice: 'gpt',
    promptFile: 'ResumeGPT.txt',
    description: 'Generate full-stack engineering resumes using the ResumeGPT prompt.',
  },
  {
    id: 'Data',
    path: '/data',
    label: 'Data',
    promptChoice: 'gpt',
    promptFile: 'ResumeGPT.txt',
    description: 'Generate data engineering and analytics resumes using the ResumeGPT prompt.',
  },
];

export const SCRAPE_CATEGORIES = CATEGORY_PAGES.map((c) => c.id);

export function getCategoryByPath(pathname) {
  return CATEGORY_PAGES.find((c) => c.path === pathname) || null;
}
